<template>
<div class="profile-page">
  <div class="profile-section">
    <div class="form-item">
      <div class="item-label">账号</div>
      <div class="item-content">
        <div class="row">{{User.mobile_phone}}</div>
      </div>
      <div class="item-btn">
        <button class="s-btn btn-blue is-plain btn-xs" v-if="!is_admin" @click="onSignOutAccount">注销</button>
      </div>
    </div>
    <div class="form-item" v-if="!User.is_palmyou">
      <div class="item-label">当前密码</div>
      <div class="item-content">
        <div class="row" v-if="!updatePassword">*********</div>
        <div class="update-password-box" v-else>
          <el-input class="input" placeholder="请输入旧密码" type="password"
					  v-model.trim="old_passwd" :maxlength="20"></el-input>

          <el-input class="input" placeholder="输入6-20位新密码"
					  v-model.trim="new_passwd" :maxlength="20"></el-input>
        </div>
      </div>
      <div class="item-btn">
        <button class="s-btn btn-blue btn-xs" v-if="updatePassword" @click="submitUpdatePassword">保存</button>
        <button class="s-btn btn-blue is-plain btn-xs" v-else @click="handleUploadPassword">修改密码</button>
      </div>
    </div>
  </div>
  <div class="profile-section">
    <div class="form-item">
      <div class="item-label">联系人</div>
      <div class="item-content">
        <div class="row">{{User.name}}</div>
      </div>
      <div class="item-btn">
        <button class="s-btn btn-blue btn-xs" v-if="updateBaseInfo" @click="submitBaseInfo">保存</button>
        <button class="s-btn btn-blue is-plain btn-xs" v-else @click="handleUpdateBaseInfo">修改信息</button>
      </div>
    </div>
    <div class="form-item">
      <div class="item-label">手机号</div>
      <div class="item-content">
        <div class="row" v-if="!updateBaseInfo">{{User.phone_number}}</div>
        <el-input class="input" v-else placeholder="请输入手机号"
				  v-model.trim="phone_number" :maxlength="11"></el-input>
      </div>
    </div>
    <div class="form-item">
      <div class="item-label">邮箱</div>
      <div class="item-content">
        <div class="row" v-if="!updateBaseInfo">{{User.email || '未绑定'}}</div>
        <el-input class="input" v-else placeholder="请输入邮箱地址"
				  v-model.trim="email" :maxlength="50"></el-input>
      </div>
    </div>
  </div>
  <div class="profile-section">
    <div class="form-item">
      <div class="item-label">微信绑定</div>
      <div class="item-content">
        <div class="wx-info">
          <img v-if="User.wxinfo && User.wxinfo.avatarurl" class="wx-img" :src="User.wxinfo.avatarurl" alt="">
          <div class="wx-name">{{User.wxinfo && User.wxinfo.openid ? (User.wxinfo.nickname || '匿名用户') : '未绑定'}}</div>
        </div>
      </div>
      <div class="item-btn">
        <button class="s-btn btn-blue is-plain btn-xs" @click="handleShowRebindWxDialog">修改微信</button>
      </div>
    </div>
  </div>
  <div class="profile-section policy">
   查看<router-link :to="{ name: 'PrivacyPolicy', params: { to: 'peer' } }" target="_blank" class="link-text">《用户协议》</router-link><router-link :to="{ name: 'PrivacyPolicy', params: { to: 'privicy' } }" target="_blank" class="link-text">《隐私政策》</router-link>
  </div>
  <div class="logout-box" v-if="!User.is_palmyou">
    <div class="logout s-btn btn-info" @click="handleLogout">退出登录</div>
  </div>

  <rebind-wx-dialog
    :show.sync="showRebindWxDialog"
  ></rebind-wx-dialog>
</div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import User from '../../../libs/user';
import RebindWxDialog from './components/rebind-wx-dialog';
import utils from '../../../libs/utils';
import Http from '../../../libs/http';


export default {
  components: {
    RebindWxDialog,

  },
  data() {
    return {
      User,
      updatePassword: false,
      updateBaseInfo: false,
      old_passwd: '',
      new_passwd: '',
      phone_number: '',
      email: '',
      showRebindWxDialog: false,
      is_admin: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      Http.post('/peer_account_query', { }).then((data) => {
        User.login(utils.extend({}, data, { token: User.token, is_palmyou: User.is_palmyou }), +localStorage.getItem('remember'));
        this.email = data.email;
        this.phone_number = data.phone_number;
        this.is_admin = data.is_admin;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    handleUploadPassword(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.updatePassword = true;
    },
    handleUpdateBaseInfo(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.updateBaseInfo = true;
    },
    handleShowRebindWxDialog(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.showRebindWxDialog = true;
    },
    handleLogout(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      User.logout();
    },
    submitUpdatePassword(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      if (!this.old_passwd) {
        return utils.msg.warning('请输入旧密码');
      }
      if (!this.new_passwd) {
        return utils.msg.warning('请输入新密码');
      }
      if (this.new_passwd.length < 6 || this.new_passwd.length > 20) {
        return utils.msg.warning('输入6-20位新密码');
      }

      Http.post('/peer_account_update', {
        peer_account_id: this.User.peer_account_id,
        old_passwd: utils.md5(this.old_passwd),
        new_passwd: utils.md5(this.new_passwd),
      }).then(() => {
        utils.msg.success('修改成功');
        this.updatePassword = false;
        this.old_passwd = '';
        this.new_passwd = '';
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    submitBaseInfo(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      if (!this.phone_number || !/^1\d{10}$/.test(this.phone_number)) {
        return utils.msg.warning('请输入正确的手机号');
      }
      if (this.email && !/^\S+@\S+.\S+$/.test(this.email)) {
        return utils.msg.warning('请输入正确的邮箱');
      }
      const newData = {
        peer_account_id: this.User.peer_account_id,
        email: this.email,
        phone_number: this.phone_number,
      };
      Http.post('/peer_account_update', newData).then(() => {
        utils.msg.success('修改成功');
        this.updateBaseInfo = false;
        User.email = this.email;
        User.phone_number = this.phone_number;

      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 账号注销
    onSignOutAccount() {
      this.$router.push({ name: 'signOut' });
    },
  },
};
</script>

<style lang="less" scoped>
.profile-page{
  padding: 0 24px;
  .profile-section{
    border-bottom: 1px solid #DEE2E6;
    padding: 32px 0;
    .form-item{
      display: flex;
      margin-bottom: 16px;
      &:last-child{
        margin-bottom: 0;
      }
      .item-label{
        width: 66px;
        flex-shrink: 0;
        color: #2F333D;
        font-size: 14px;
        line-height: 40px;
        font-weight: 600;
      }
      .item-content{
        width: 460px;
        flex-shrink: 0;
        color: #2F333D;
        font-size: 14px;
        .row{
          padding: 0 12px;
          line-height: 40px;
        }
        .update-password-box{
          .input{
            margin-bottom: 16px;
            &:last-child{
              margin-bottom: 0;
            }
            /deep/ .el-input__inner{
              height: 40px;
              border-radius: 2px;
            }
          }
        }
        .wx-info{
          display: flex;
          align-items: center;
          padding-left: 12px;
          .wx-img{
            width: 48px;
            height: 48px;
            border-radius: 50%;
          }
          .wx-name{
            color: #2F333D;
            font-size: 12px;
            margin-left: 10px;
          }
        }
      }
      .item-btn{
        flex-grow: 1;
        overflow: hidden;
        padding-top: 2px;
        display: flex;
        justify-content: flex-end;
        .s-btn{
          min-width: 74px;
        }
      }
    }
    &.policy {
      padding: 28px 0;
      font-size: 14px;
      color: #2F333D;
      line-height: 16px;
      border-bottom: 1px solid transparent;
      .link-text {
        color: #599FFF;
        padding: 0;
      }
    }
  }
  .logout-box{
    display: flex;
    justify-content: center;
    .logout{
      margin: 40px auto;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/Profile.vue